import type { FormControlLabelProps } from '@mui/material';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';

export type LookoCheckboxType = {
  disabled?: boolean;
  label?: React.ReactNode;
  value?: FormControlLabelProps['value'];
  checked?: boolean;
  onChange?: FormControlLabelProps['onChange'];
};
/**
 * Looko Checkbox
 * @see https://www.figma.com/file/PFrAvDaThtf8qMSRc9pNaV/Looko---Design-System?type=design&node-id=857-38534&mode=design&t=ZgYy5aCgHeFtA5LM-0
 */
export const LookoCheckbox = (props: LookoCheckboxType) => {
  return (
    <FormControlLabel
      {...props}
      label={<Typography variant="Body_Looko">{props.label}</Typography>}
      control={
        <Checkbox
          size="small"
          sx={{
            padding: 0.5,
            margin: 0,
            width: 32,
            height: 32,
          }}
        />
      }
      sx={{ margin: 0 }}
    />
  );
};
